import { render, staticRenderFns } from "./DivisoriaDescricao.vue?vue&type=template&id=35ef9574&"
import script from "./DivisoriaDescricao.vue?vue&type=script&lang=js&"
export * from "./DivisoriaDescricao.vue?vue&type=script&lang=js&"
import style0 from "./DivisoriaDescricao.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports